import React from 'react'

import { NotificationsHomeProvider } from '../../context'
import NotificationsButton from '../NotificationsButton'
import NotificationsHomeBody from '../NotificationsHomeBody'

const NotificationsHomeWrapper = (props) => {
  return (
    <NotificationsHomeProvider {...props}>
      <div>
        <NotificationsButton />
        <NotificationsHomeBody />
      </div>
    </NotificationsHomeProvider>
  )
}

export default NotificationsHomeWrapper
